import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import AppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import axios from "axios";
import Button from "@material-ui/core/Button";
import TextField from "@material-ui/core/TextField";
import Typography from "@material-ui/core/Typography";
import { withStyles, makeStyles } from "@material-ui/core/styles";
import Container from "@material-ui/core/Container";
import Backdrop from "@material-ui/core/Backdrop";
import CircularProgress from "@material-ui/core/CircularProgress";
import * as Util from "../utils/util.js";
import { SHA256 } from "crypto-js";

const CssTextField = withStyles({
  root: {
    "& label.Mui-focused": {
      color: "#65B7D9",
    },
    "& .MuiInput-underline:after": {
      borderBottomColor: "#65B7D9",
    },
    "& .MuiOutlinedInput-root": {
      "&.Mui-focused fieldset": {
        borderColor: "#65B7D9",
      },
    },
  },
})(TextField);

const useStyles = makeStyles((theme) => ({
  textField_ID: {
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(1),
  },

  textField_PW: {
    marginBottom: theme.spacing(1),
  },

  button: {
    marginTop: theme.spacing(2),
    width: "100%",
    height: "45px",
    backgroundColor: "#5EB3D7",
    color: "#ffffff",
    "&:focus": {
      backgroundColor: "#5EB3D7",
    },
  },

  backdrop: {
    zIndex: 1252,
    color: "#fff",
  },
}));

function Login(props) {
  const classes = useStyles();
  const navigate = useNavigate();
  const [inputs, setInputs] = useState({
    ID: "",
    PW: "",
  });

  const { ID, PW } = inputs;
  const [loading, setLoading] = React.useState(false);

  const handleChange = (e) => {
    const { value, name } = e.target;
    setInputs({
      ...inputs,
      [name]: value,
    });
  };

  useEffect(() => {
    window.sessionStorage.clear();
  }, []);

  const signIn = (user_id, pass) => {
    setLoading(true);
    const sha256pass = SHA256(pass).toString();
    let form = new FormData();
    form.append("id", user_id);
    form.append("pass", sha256pass);

    axios
      .post(Util.getBaseUrl() + "login/signIn", form)
      .then((response) => {
        if (response.data.code === "0") {
          if (response.data.PROGRAM.length === 0) {
            alert("프로그램 권한이 존재하지 않습니다.");
            setLoading(false);
          } else {
            window.sessionStorage.setItem("user_id", response.data.DATA.USER_ID);
            window.sessionStorage.setItem("user_name", response.data.DATA.USER_NAME);
            window.sessionStorage.setItem("workplace_cd", response.data.DATA.CUST_CD);
            window.sessionStorage.setItem("workplace_nm", response.data.DATA.CUST_NAME);
            window.sessionStorage.setItem("tel_no", response.data.DATA.TEL_NO);
            window.sessionStorage.setItem("e_mail", response.data.DATA.E_MAIL);
            window.sessionStorage.setItem("sellCustCd", JSON.stringify(response.data.DATA_CUSTOM));
            window.sessionStorage.setItem("code_nm", JSON.stringify(response.data.CODE_NM));
            window.sessionStorage.setItem("code_stan", JSON.stringify(response.data.CODE_STAN));
            window.sessionStorage.setItem("program", JSON.stringify(response.data.PROGRAM));
            console.log(response.data);
            navigate("/home", {
              replace: true,
              state: { program: response.data.PROGRAM },
            });
          }
        } else {
          setLoading(false);
          alert(response.data.RESULT_MESSAGE);
        }
      })
      .catch((e) => {
        console.error(e);
        alert(e.message);
      });
  };

  return (
    <div className="tab-root">
      <div
        style={{
          width: "100%",
          height: "100%",
          padding: "6px 8px",
          boxSizing: "border-box",
          backgroundColor: "rgb(233, 237, 246)",
          borderRadius: "14px",
        }}
      >
        <Backdrop className={classes.backdrop} open={loading}>
          <CircularProgress color="inherit" />
        </Backdrop>
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            height: "100%",
            justifyContent: "center",
            textAlign: "center",
            color: "rgb(21,35,91)",
          }}
        >
          <div style={{ fontSize: "2.5rem", fontWeight: "700" }}>(주)동명스틸</div>
          <div
            style={{
              width: "64mm",
              display: "flex",
              flexDirection: "column",
              margin: "64px auto",
            }}
          >
            <div
              style={{
                fontSize: "1.6rem",
                fontWeight: "700",
                letterSpacing: "1px",
              }}
            >
              DAON CRM
            </div>
            <div style={{ width: "100%" }}>
              <CssTextField
                onKeyUp={Util.enterToFocusMove}
                className={classes.textField_ID}
                variant="outlined"
                required
                id="ID"
                label="아이디"
                name="ID"
                onChange={(e) => handleChange(e)}
                value={ID}
                size="small"
                autoFocus
                InputProps={{
                  style: {
                    fontSize: "15px",
                    width: "64mm",
                    backgroundColor: "white",
                  },
                }}
              />
            </div>
            <div>
              <CssTextField
                onKeyUp={(e) => {
                  if (e.key === "Enter") {
                    signIn(ID, PW);
                  }
                }}
                className={classes.textField_PW}
                variant="outlined"
                required
                name="PW"
                label="비밀번호"
                type="password"
                id="PW"
                onChange={(e) => handleChange(e)}
                value={PW}
                size="small"
                InputProps={{
                  style: {
                    fontSize: "15px",
                    width: "64mm",
                    backgroundColor: "white",
                  },
                }}
              />
            </div>
            <div>
              <Button className={classes.button} onClick={() => signIn(ID, PW)} variant="contained">
                <Typography>로 그 인</Typography>
              </Button>
            </div>
          </div>
          <div
            style={{
              display: "flex",
              flexDirection: "column",
            }}
          ></div>
        </div>
      </div>
      <img
        src={"./images/micromos.png"}
        style={{
          position: "absolute",
          top: "18px",
          left: "18px",
          width: "36mm",
          margin: "0 auto",
        }}
      />
    </div>
  );
}
export default withStyles(useStyles)(Login);
